import * as React from 'react';
import * as dateFns from 'date-fns';
import {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHeaderCell,
  TableCell,
} from 'arbina-ui';
import { Pack } from 'types';
import * as style from './style.sass';

interface Properties {
  items: Pack[];
  onStartEditItem: (pack: Pack) => any;
  onDeleteItem: (pack: Pack) => any;
}

interface State {
  windowHeight: number;
}

export class PackTable extends React.Component<Properties> {
  state: State = {
    windowHeight: window.innerHeight,
  };

  setHeight() {
    this.setState({ windowHeight: window.innerHeight });
  }

  componentDidMount() {
    window.addEventListener('resize', this.setHeight.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setHeight.bind(this));
  }

  getAggregatedStatistics = (pack: Pack) => {
    const opened = pack.statistics ?
      pack.statistics.reduce((p, c) => p + (c.stat['PACK_OPENED'] || 0), 0) :
      0;

    const packFinished = pack.statistics ?
      pack.statistics.reduce((p, c) => p + (c.stat['PACK_FINISHED'] || 0), 0) :
      0;

    const itemStarted = pack.statistics ?
      pack.statistics.reduce((p, c) => p + (c.stat['ITEM_STARTED'] || 0), 0) :
      0;

    const itemFinished = pack.statistics ?
      pack.statistics.reduce((p, c) => p + (c.stat['ITEM_FINISHED'] || 0), 0) :
      0;

    const purchased = pack.statistics ?
      pack.statistics.reduce((p, c) => p + (c.stat['PURCHASED'] || 0), 0) :
      0;

    return {
      opened,
      packFinished,
      itemStarted,
      itemFinished,
      purchased,
    };
  }

  getAggregatedItemStatistics = (pack: Pack, itemId: string) => {
    const itemStatistics = pack.statistics ?
      pack.statistics.filter(s => s.itemId === itemId) : [];

    const started = itemStatistics.reduce((p, c) => p + (c.stat['ITEM_STARTED'] || 0), 0);
    const finished = itemStatistics.reduce((p, c) => p + (c.stat['ITEM_FINISHED'] || 0), 0);

    return {
      started,
      finished,
    };
  }

  render() {
    const { items, onStartEditItem, onDeleteItem } = this.props;
    const { windowHeight } = this.state;

    return (<div>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHeaderCell>
              Items
            </TableHeaderCell>
            <TableHeaderCell className={style.statisticsCell}>
              Statistics
            </TableHeaderCell>
            {/*<TableHeaderCell className={style.createdCell}>*/}
            {/*Created*/}
            {/*</TableHeaderCell>*/}
            {/*<TableHeaderCell className={style.updatedCell}>*/}
            {/*Updated*/}
            {/*</TableHeaderCell>*/}
            <TableHeaderCell className={style.publishedCell}>
              Published
            </TableHeaderCell>
            {/*<TableHeaderCell className={style.propertiesCell}>*/}
            {/*Properties*/}
            {/*</TableHeaderCell>*/}
            <TableHeaderCell className={style.manageCell}/>
          </TableRow>
        </TableHeader>
      </Table>
      <div
        className={style.container}
        style={{ height: windowHeight - 160 }}
      >
        <Table>
          <TableBody>
            <>
              {!items.length ? <TableRow>
                <TableCell colSpan={7}>No items to show.</TableCell>
              </TableRow> : null}
              {items.map((pack) => {
                const aggregated = this.getAggregatedStatistics(pack);

                return ((<TableRow
                  key={pack.id}
                >
                  <TableCell>
                    {pack.items.map((item) => {
                      const paid = item.properties.indexOf('PAID') !== -1;
                      const statistics = this.getAggregatedItemStatistics(pack, item.id);

                      return (<div
                        className={`${style.preview} ${paid ? style.borderedPreview : ''}`}
                      >
                        <span>{statistics.started} / {statistics.finished}</span>
                        <div>
                          <img
                            key={item.imageUrl}
                            src={item.imageUrl}
                          />
                          <img
                            key={item.meshedImageUrl}
                            src={item.meshedImageUrl}
                          />
                        </div>
                        {paid && <div className={style.paid}>❤️</div>}
                      </div>);
                    })}
                  </TableCell>
                  <TableCell
                    className={style.statisticsCell}
                    title={`Statistics:
Pack: open / finished
Items: started / finished
Purchased: count`}
                  >
                    {!pack.statistics && '-'}
                    {!!pack.statistics && <div className={style.statistics}>
                <span>
                  <b>Pack:</b> {aggregated.opened} /
                  {' '}
                  {aggregated.packFinished}
                </span>
                      <span>
                  <b>Items:</b> {aggregated.itemStarted} /
                        {' '}
                        {aggregated.itemFinished}
                </span>
                      <span><b>Purchased:</b> {aggregated.purchased}</span>
                    </div>}
                  </TableCell>
                  {/*<TableCell className={style.createdCell}>*/}
                  {/*{dateFns.format(new Date(pack.createdAt), 'DD.MM.YYYY HH:mm:ss')}*/}
                  {/*</TableCell>*/}
                  {/*<TableCell className={style.updatedCell}>*/}
                  {/*{pack.updatedAt ?*/}
                  {/*dateFns.format(new Date(pack.updatedAt), 'DD.MM.YYYY HH:mm:ss') :*/}
                  {/*null}*/}
                  {/*</TableCell>*/}
                  <TableCell className={style.publishedCell}>
                    {pack.publishAt ?
                      dateFns.format(new Date(pack.publishAt), 'DD.MM.YYYY HH:mm:ss') :
                      '-'}
                  </TableCell>
                  {/*<TableCell className={style.propertiesCell}>*/}
                  {/*{!!pack.properties.length ? pack.properties.join(', ') : '-'}*/}
                  {/*</TableCell>*/}
                  <TableCell className={style.manageCell}>
                    <a onClick={onStartEditItem.bind(this, pack)}>⚙</a>
                    <a onClick={onDeleteItem.bind(this, pack)}>🗑</a>
                  </TableCell>
                </TableRow>));
              })}
            </>
          </TableBody>
        </Table>
      </div>
    </div>);
  }
}
